module.exports = Object.freeze({
    NETS_EMAIL_ERROR: 'Invalid Email Address',
    NETS_CERT_ZIP_FILE_TYPE: 'Please do not zip the cert. Upload the cert in the original format (.cer)',
    NETS_CERT_MAX_NO_OF_SIZE_LIMIT: 'You have exceeded the maximum number of files allowed.',
    NETS_CERT_ONE_FILE_UPLOAD_ERROR : 'Please upload only one file at a time during the upload process',
    NETS_CERT_COMMON_ERROR : 'Invalid file format. Please upload cert in .cer format only',
});